// extracted by mini-css-extract-plugin
export var backupIcon = "_p3-1";
export var image = "_p3-0";